<ifr-page-title pageTitle="'LEFT_PANEL_EVACUATION_LIST' | translate "/>
<evacuation-list-container />
